//**************************************************************
// メニュー　領域外をクリックしたら閉じる
//**************************************************************
jQuery(document).ready(function($) {
  var nav = $('.navbar-collapse');
  $('.main-section').click(function() {
   //ここでnavの部分がactiveクラスを持っているか確認
    if(nav.hasClass('show')) {
      $('.navbar-collapse').removeClass('show');
    }
  });
});


//**************************************************************
// 1. scroll fade animation （ フェード系アニメーション ）
//**************************************************************
// 自分がどの高さをみているのかを取得する
$(window).scroll(function () {
  $('.fadeInUp, .fadeInRight, .fadeInLeft, .fadeIn').each(function() {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 100) {
      $(this).addClass('scrollin');
    }
  });
});

//**************************************************************
// スムーズスクロール
//**************************************************************
$(function () {
  $('a[href^="#"]').on('click', function () {
    var href = $(this).attr('href');
    var target;
    if (href == '#' || href == '') {
      target = $('html');
    } else {
      target = $(href);
    }
    var posi = target.offset().top;
    $('html,body').animate({
      'scrollTop': posi
    }, 500);
    return false;
  });
});
